import React, { useState } from 'react';
import { HoverCard, HoverCardTrigger, HoverCardContent } from '../ui/hover-card';
import { resolveImageUrl } from '../../lib/imageCache';

// Wraps a Collection (material) chip: hovering shows a large texture of the fabric + a strip of its colors
export const CollectionHoverPreview = ({ material, label, title, subtitle, disabled = false, children }) => {
  const colors = (material?.colors || []).filter(c => c.image_url || c.hex_color);
  const hero = colors.find(c => c.image_url) || colors[0];
  const [open, setOpen] = useState(false);
  if (!hero || disabled) return children;
  return (
    <HoverCard openDelay={600} closeDelay={0} open={open} onOpenChange={setOpen}>
      {/* Closes on click so the preview never covers the color grid that opens below */}
      <HoverCardTrigger asChild onClickCapture={() => setOpen(false)}>{children}</HoverCardTrigger>
      {/* Look-only preview: never captures the pointer, so neighbouring chips stay clickable */}
      <HoverCardContent side="top" align="start" sideOffset={8} avoidCollisions collisionPadding={12} className="hidden md:block w-[240px] p-0 overflow-hidden rounded-xl border-neutral-200 shadow-2xl pointer-events-none" data-testid={`collection-hover-${material.id}`}>
        <div className="relative aspect-square bg-neutral-100">
          {hero.image_url ? (
            <img src={resolveImageUrl(hero.image_url, 512)} alt={material.name} className="w-full h-full object-cover" data-testid="collection-hover-texture" />
          ) : (
            <div className="w-full h-full" style={{ backgroundColor: hero.hex_color }} />
          )}
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-3 pt-8 pb-2.5 text-white">
            <p className="text-[10px] uppercase tracking-wider text-white/70">{label}</p>
            <p className="font-medium leading-tight">{title || material.name}</p>
            {subtitle && <p className="text-[11px] text-amber-200">{subtitle}</p>}
            <p className="text-xs text-white/80">{colors.length} {colors.length === 1 ? 'color' : 'colors'}{hero.name ? ` · shown: ${hero.name}` : ''}</p>
          </div>
        </div>
        {colors.length > 1 && (
          <div className="flex gap-1 p-2 bg-white" data-testid="collection-hover-strip">
            {colors.slice(0, 8).map((c) => (
              <div key={c.id} className="flex-1 aspect-square rounded-md overflow-hidden border border-black/10" title={c.name}>
                {c.image_url ? <img src={resolveImageUrl(c.image_url, 128)} alt={c.name} loading="lazy" className="w-full h-full object-cover" /> : <div className="w-full h-full" style={{ backgroundColor: c.hex_color }} />}
              </div>
            ))}
            {colors.length > 8 && <div className="flex-1 aspect-square rounded-md bg-neutral-100 text-[10px] text-neutral-500 flex items-center justify-center">+{colors.length - 8}</div>}
          </div>
        )}
      </HoverCardContent>
    </HoverCard>
  );
};
